import React from 'react';
import autobind from 'autobind-decorator';
import {
    ConservationAction,
    ConservationActionPermit
} from "../../../Models";
import {
    GenericModelViewer,
} from "../../Common/GenericModelViewer";

import {SurveyFormInputGenericModelViewer} from "../../Common/SurveyForm";

export class PermitSurveySection extends SurveyFormInputGenericModelViewer {
    constructor(props) {
        super(props);
    }

    @autobind
    getModel() {
        const permitTypeId = this.props.Question.permitTypeId;
        const conservationActionId = this.props.ConservationAction.conservationActionId;
        const surveyTypeId = this.props.SurveyTypeId;

        if(this.alteredConservationActionModel) {
            const conservationActionPermitFieldDef = this.alteredConservationActionModel
                .getFlattenedFieldDefs()
                .find((field) => field.key === "ConservationActionPermits");

            if(conservationActionPermitFieldDef.customData?.permitTypeId === permitTypeId) {
                return this.alteredConservationActionModel;
            }
        }

        const conservationActionModel = new ConservationAction();
        const alteredConservationActionPermitModel = new ConservationActionPermit();
        const conservationActionPermitFieldDefs = conservationActionModel
            .getFlattenedFieldDefs()
            .find((field) => field.key === "ConservationActionPermits");

        alteredConservationActionPermitModel.defaults = {
            conservationActionId,
            Permit: {permitTypeId}
        };

        // hide permitId and show conservationActionId
        alteredConservationActionPermitModel.getFlattenedFieldDefs()
            .find((field) => field.key === "permitId")
            .isHidden = false;

        alteredConservationActionPermitModel.getFlattenedFieldDefs()
            .find( (field) => field.key === "conservationActionId" )
            .isHidden = true;

        conservationActionPermitFieldDefs.customData = {permitTypeId, surveyTypeId};
        conservationActionPermitFieldDefs.model = alteredConservationActionPermitModel;

        return this.alteredConservationActionModel = conservationActionModel;
    }

    render() {
        const { OnConservationActionChange, EditMode, ConservationAction } = this.props;
        const model = this.getModel();
        const hiddenGroups = model.getFieldDefGroups().filter((group) => group.key !== "Permits").map((x) => x.key);

        return <GenericModelViewer
            Model={model}
            IsNewModel={false}
            EditMode={EditMode}
            HideGroups={hiddenGroups}
            Data={ConservationAction}
            Update={OnConservationActionChange}
            OnValidationUpdate={this.updateValidation}
        />;
    }
}


